module.exports = __webpack_public_path__ + "images/emoji/cat2.126467c8b612616b94cb.png";